import Vue from "vue";
import "./plugins/sentry";
import "./plugins/vuetify";
import "./plugins/firebase";
import "./plugins/moment";
import "./plugins/googleAPI";
import App from "./App.vue";
import router from "./router";
import store from "./store";

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
